import { CoralClientConfigNotFound } from './errors';
function hasRequiredFields(config) {
    return config != null &&
        config.httpEndpoint != null &&
        config.httpEndpoint.url != null;
}
/**
 * Config factory backed by key-value pairs where the key is the qualifier and the value is CoralConfigSchema instance.
 */
export class CoralClientConfigFactory {
    constructor(service, configs) {
        this.service = service;
        this.getConfigForQualifier = (qualifier) => {
            const config = configs[qualifier];
            if (hasRequiredFields(config)) {
                return config;
            }
            throw new CoralClientConfigNotFound(this.service, { qualifier });
        };
    }
}
